import React from 'react';

const IconComponent = ({ image }) => {
  const svgPath = image === null ?`/images/sandwich.svg#sandwich`:`/images/${image}.svg#${image}`; // Update the path accordingly
  return (
    <>
      <figure className="icon">
        <svg>
          <use xlinkHref={svgPath} />
        </svg>
      </figure>
    </>
  );
};

export default IconComponent;
